import React from 'react';
import _merge from 'lodash/merge';
import { getContext } from 'common';

import Styled from './styles';

export interface FindMatchContainerProps extends React.ComponentPropsWithRef<'div'> {
  /** Children prop is where content resides. */
  children?: React.ReactNode;
  /** To override the theme please refer to the "Readme" tab to learn more. */
  theme?: any;
  /** Displayed number of matched items and the index of selected item */
  matchNumberContent?: string | number | React.ReactNode;
}

/** Simple wrapper for match count and arrow buttons
 * Any other props than the explicitly defined props will be provided to the wrapper. */
const FindMatchContainer = React.forwardRef<HTMLElement, FindMatchContainerProps>((props: FindMatchContainerProps, ref) =>
  getContext(({ RTL, theme }) => {
    const { matchNumberContent, children, theme: themeProp, ...otherProps } = props;
    const resolvedTheme = _merge({}, theme.FILTER_FIELD, themeProp);
    return (
      <Styled.FilterMatchesContainer ref={ref} $rtl={RTL} {...otherProps}>
        <Styled.MatchCountContainer $theme={resolvedTheme} $rtl={RTL}>
          {matchNumberContent}
        </Styled.MatchCountContainer>
        {children && <Styled.ArrowButtonsContainer>{children}</Styled.ArrowButtonsContainer>}
      </Styled.FilterMatchesContainer>
    );
  }));

FindMatchContainer.displayName = 'FindMatchContainer';
FindMatchContainer.defaultProps = {
  children: undefined,
  theme: {},
  matchNumberContent: ''
};

export default FindMatchContainer;
